import remarkGFM from "remark-gfm";
import Markdown from "react-markdown";
import { cn } from "@aichat/ui/lib/utils";
type MarkdownRendererProps = {
  text: string;
  className?: string;
};

function MarkdownRenderer({ text, className }: MarkdownRendererProps) {
  return (
    <div className={cn("markdown prose [&>p]:break-words", className)}>
      <Markdown
        remarkPlugins={[remarkGFM]}
        components={{
          a: ({ ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer" />
          ),
        }}
      >
        {text.replace(/\n+/g, "\n")}
      </Markdown>
    </div>
  );
}

export default MarkdownRenderer;
